export const AI_CONVO_TITLE_MAX_LENGTH = 140;

export interface AIConvoHistoryItem {
    id: number;
    sessionId: string;
    title: string | null;
    creationTimestamp: Date;
    lastModifyTimestamp: Date;
}

export type AIConvoHistoryGroup =
    'today' | 'yesterday' | 'last7days' | 'older' | 'ungrouped';

export interface AIConvoHistoryGrouped {
    group: AIConvoHistoryGroup;
    items: AIConvoHistoryItem[];
}
